"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Layers = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.9061385,5.13334722 L21.7029822,9.04305553 C22.0291901,9.16189575 22.1654968,9.72402954 21.7029534,9.95687984 L19.3558928,10.9998412 L21.7030111,12.0430491 C22.147644,12.2167816 22.0721436,12.8132324 21.7029752,12.9568702 L19.3558928,13.9998412 L21.7030981,15.0430878 C22.0738373,15.2137146 22.1289215,15.7463837 21.703091,15.9568961 L12.9061385,19.8666528 C12.6475731,19.9815707 12.3524269,19.9815707 12.0938615,19.8666528 L3.29672405,15.9568139 C2.90855408,15.7811432 2.90855408,15.2047577 3.29665584,15.0430327 L5.64289277,13.9998412 L3.29659387,12.9568431 C2.87321685,12.7829606 2.92113338,12.1595414 3.29655797,12.0430762 L5.64289277,10.9998412 L3.29680055,9.95693493 C2.8809996,9.74715268 2.9187176,9.2044907 3.29683285,9.04313774 L12.0938615,5.13334722 C12.3524269,5.01842928 12.6475731,5.01842928 12.9061385,5.13334722 Z M18.1248928,14.5468412 L12.9061803,16.8666078 C12.6475911,16.9815531 12.3524079,16.9815552 12.0938172,16.8666136 L6.87489277,14.5468412 L4.73110723,15.5 L12.5,18.9528412 L20.2688928,15.5 L18.1248928,14.5468412 Z M18.1248928,11.5468412 L12.9061803,13.8666078 C12.6475911,13.9815531 12.3524079,13.9815552 12.0938172,13.8666136 L6.87489277,11.5468412 L4.73110723,12.5 L12.5,15.9528412 L20.2688928,12.5 L18.1248928,11.5468412 Z M12.5,6.04715877 L4.73110723,9.5 L12.5,12.9528412 L20.2688928,9.5 L12.5,6.04715877 Z" })));
};
Layers.displayName = 'Layers';
exports.default = Layers;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Layers.js.map